import EventEmitter from '@remote/utils/event-emitter'

export const events = {
  update: 'update',
}
const EVENTNAMES = [events.update]
// const passageEventNamePrefix = 'UPDATE'

const LXTaskEventBus = new EventEmitter(EVENTNAMES)

export default LXTaskEventBus